import React, { useEffect } from 'react';
import './App.scss';
import { BrowserRouter as Router } from 'react-router-dom';
import { AggregateAppProvider } from './components/providers/AggregateAppProvider';
import { MainLayout } from './components/layout/MainLayout';
import { FontPreload } from './components/layout/FontPreload';
import { initKeyboardFocusVisibility } from './utils/keyboardFocus';

function App() {
	useEffect(() => initKeyboardFocusVisibility(), []);

	return (
		<Router>
			<AggregateAppProvider>
				<FontPreload />
				<MainLayout />
			</AggregateAppProvider>
		</Router>
	);
}

export default App;
